import { Item } from './Item';
export function ItemList(props) {
    const { items, type, checked, onChange } = props;
    return items.map(item => (<Item key={item.id} id={item.id} name={item.name} checked={checked} onChange={onChange} type={type}/>));
}
